
import USAFlag from '../assets/img/flags/united-states-of-america.svg';
import CanadaFlag from '../assets/img/flags/canada.svg';
import GermanyFlag from '../assets/img/flags/germany.svg';
import FranceFlag from '../assets/img/flags/france.svg';
import JapanFlag from '../assets/img/flags/japan.svg';
import ItalyFlag from '../assets/img/flags/italy.svg';
import NetherlandsFlag from '../assets/img/flags/netherlands.svg';
import SwedenFlag from '../assets/img/flags/sweden.svg';

export default [
    {
        "id": 1,
        "image": USAFlag,
        "name": "United States",
        "visits": 272.109,
        "percentage": 36
    },
    {
        "id": 2,
        "image": CanadaFlag,
        "name": "Canada",
        "visits": 160.064,
        "percentage": 20,
        "color": "secondary"
    },
    {
        "id": 3,
        "image": GermanyFlag,
        "name": "Germany",
        "visits": 120.048,
        "percentage": 15,
        "color": "tertiary"
    },
    {
        "id": 4,
        "image": FranceFlag,
        "name": "France",
        "visits": 100.048,
        "percentage": 8
    },
    {
        "id": 5,
        "image": JapanFlag,
        "name": "Japan",
        "visits": 56.022,
        "percentage": 7
    },
    {
        "id": 6,
        "image": ItalyFlag,
        "name": "Italy",
        "visits": 48.019,
        "percentage": 6
    },
    {
        "id": 7,
        "image": NetherlandsFlag,
        "name": "Netherlands",
        "visits": 40.016,
        "percentage": 5
    },
    {
        "id": 8,
        "image": SwedenFlag,
        "name": "Sweden",
        "visits": 26.016,
        "percentage": 3
    }
]